module.exports = __webpack_public_path__ + "index_pc/media/exp_05_sec.c5f9a327.aac";